var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc color legend
 */
import Es6SEt from '@byted/light-render/lib/utils/set';
import { ComponentModel } from '../../model';
import { Group, Rect, Text, LinearGradient } from '../../element';
import { createSymbol } from '../../symbol';
import { getValue } from '../../encode';
import { LinearScale, ColorScale } from '../../scale';
import { registerComponent } from '../index';
import { getRectLabelPosition } from '../../utils/textLayout';
import { clampRange } from '../../utils/boxLayout';
import { degToRad } from '../../utils/math';
import * as lodash from '../../utils/lodash';
import measureText from '../../utils/measureText';
var handleIconPath = 'M0.468872 0L2.99996 2.50513V21.4949L0.468872 24H6.53105L3.99996 21.4949V2.50513L6.53105 0H0.468872Z';
var ColorLegend = /** @class */ (function (_super) {
    __extends(ColorLegend, _super);
    function ColorLegend() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'colorLegend';
        _this.zindex = 999;
        _this._invisibleItems = new Es6SEt();
        _this._clipRect = new Rect();
        _this._panningBar = new Rect();
        _this.handleDragStart = function (side) {
            var _a = _this.state, startPosition = _a.startPosition, endPosition = _a.endPosition;
            _this._dragSide = side;
            _this._dragStartPosition = side === 'start' ? startPosition : endPosition;
            _this.setState({ isDragging: true });
        };
        _this.handleBarPanning = function (event) {
            var _a;
            var orient = _this.option.orient;
            var positionRange = _this._getPositionRange();
            var _b = _this.state, startPosition = _b.startPosition, endPosition = _b.endPosition;
            var dx = event.dx, dy = event.dy;
            var offset = orient === 'horizontal' ? dx : dy;
            startPosition += offset;
            endPosition += offset;
            _a = clampRange([startPosition, endPosition], positionRange), startPosition = _a[0], endPosition = _a[1];
            _this.setState({ startPosition: startPosition, endPosition: endPosition });
            _this._updatePosition();
        };
        _this.handleDragMove = function (event) {
            var _a = _this._getNextPosition(event), startPosition = _a[0], endPosition = _a[1];
            _this.setState({
                startPosition: startPosition,
                endPosition: endPosition,
            });
            _this._updatePosition();
        };
        return _this;
    }
    ColorLegend.prototype.getDefaultOption = function () {
        return {
            show: false,
            type: 'continuous',
            position: 'bottom',
            align: 'center',
            inactiveColor: '#EFF1F9',
            orient: 'horizontal',
            inverse: false,
            margin: 20,
            floating: false,
            splitNumber: 5,
            offsetX: 0,
            offsetY: 0,
            barLength: 100,
            barWidth: 16,
            itemSymbol: 'rect',
            itemWidth: 16,
            itemHeight: 16,
            itemGap: 2,
            itemStyle: {},
            textGap: 8,
            formatter: null,
            handleSize: [7, 24],
            handleIcon: "path://" + handleIconPath,
            textStyle: {
                color: '#838DB3',
                fontSize: 12,
            },
            handleStyle: {
                fill: '#222C37',
                stroke: 'rgba(0, 0, 0, 0)',
                lineWidth: 6,
            },
        };
    };
    ColorLegend.prototype.getInitialState = function () {
        return {
            _valid: false,
            isDragging: false,
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            start: null,
            end: null,
            startPosition: 0,
            endPosition: 0,
            min: 0,
            max: 0,
            colors: [],
            items: [],
        };
    };
    ColorLegend.prototype.init = function () {
        var _this = this;
        var _a = this.option, handleIcon = _a.handleIcon, _b = _a.handleSize, handleWidth = _b[0], handleheight = _b[1];
        var getDragOffset = function () {
            return { x: 0, y: 0 };
        };
        this.applyPosition = lodash.throttle(this.applyPosition.bind(this), 100);
        var startHandle = createSymbol({
            symbol: handleIcon,
        }, { x: 0, y: 0, width: handleWidth, height: handleheight }, {}).setAttr({
            key: this.getKey('start-handle'),
            draggable: true,
            onDragStart: function () { return _this.handleDragStart('start'); },
            onDrag: this.handleDragMove,
            onDragend: function () { return _this.setState({ isDragging: false }); },
            getDragOffset: getDragOffset,
        });
        var endHandle = createSymbol({
            symbol: handleIcon,
        }, { x: 0, y: 0, width: handleWidth, height: handleheight }, {}).setAttr({
            key: this.getKey('end-handle'),
            draggable: true,
            onDragStart: function () { return _this.handleDragStart('end'); },
            onDrag: this.handleDragMove,
            onDragEnd: function () { return _this.setState({ isDragging: false }); },
            getDragOffset: getDragOffset,
        });
        this._handleIcons = [startHandle, endHandle];
    };
    ColorLegend.prototype.getLegendSize = function () {
        var _a = this.option, type = _a.type, inverse = _a.inverse, barLength = _a.barLength, barWidth = _a.barWidth, orient = _a.orient, splitNumber = _a.splitNumber, itemWidth = _a.itemWidth, itemHeight = _a.itemHeight, itemGap = _a.itemGap, textStyle = _a.textStyle, textGap = _a.textGap;
        var width;
        var height;
        var outerWidth;
        var outerHeight;
        var x = 0;
        var y = 0;
        if (type === 'continuous') {
            width = orient === 'horizontal' ? barLength : barWidth;
            height = orient === 'horizontal' ? barWidth : barLength;
        }
        else if (orient === 'horizontal') {
            width = itemWidth * splitNumber + (splitNumber - 1) * itemGap;
            height = itemHeight;
        }
        else if (orient === 'vertical') {
            width = itemWidth;
            height = itemHeight * splitNumber + (splitNumber - 1) * itemGap;
        }
        outerWidth = width;
        outerHeight = height;
        var encodeInfo = this.getEncodeInfo();
        if (!encodeInfo) {
            return;
        }
        var min = encodeInfo.min, max = encodeInfo.max;
        var _b = this.getFormatedText(min, max), minText = _b[0], maxText = _b[1];
        var startText = inverse ? maxText : minText;
        var endText = inverse ? minText : maxText;
        var startTextWidth = measureText("" + startText, textStyle).width;
        var endTextWidth = measureText("" + endText, textStyle).width;
        if (orient === 'vertical') {
            y += textStyle.fontSize + textGap;
            outerWidth = Math.max(itemWidth, startTextWidth, endTextWidth);
            outerHeight += (textStyle.fontSize + textGap) * 2;
            x = (outerWidth - width) / 2;
        }
        else if (orient === 'horizontal') {
            x += startTextWidth + textGap;
            outerHeight = Math.max(height, textStyle.fontSize);
            outerWidth += startTextWidth + endTextWidth + textGap * 2;
            y = (outerHeight - height) / 2;
        }
        return {
            x: x,
            y: y,
            width: width,
            height: height,
            outerWidth: outerWidth,
            outerHeight: outerHeight,
        };
    };
    ColorLegend.prototype.getSideAreaSize = function () {
        var _a = this.option, show = _a.show, position = _a.position, floating = _a.floating, margin = _a.margin;
        if (floating || !show || !this.getEncodeInfo()) {
            return {
                side: position,
                size: 0,
            };
        }
        var _b = this.getLegendSize(), outerWidth = _b.outerWidth, outerHeight = _b.outerHeight;
        if (position === 'bottom' || position === 'top') {
            return {
                side: position,
                size: outerHeight + margin,
            };
        }
        if (position === 'left' || position === 'right') {
            return {
                side: position,
                size: outerWidth + margin,
            };
        }
    };
    ColorLegend.prototype.getEncodeInfo = function () {
        var _a;
        var seriesModel = this.chart.getSeriesModel(0);
        var colorEncode = (_a = seriesModel === null || seriesModel === void 0 ? void 0 : seriesModel.getOption().encode) === null || _a === void 0 ? void 0 : _a.color;
        if (!colorEncode) {
            return;
        }
        if (!(Array.isArray(colorEncode) && typeof colorEncode[1] === 'string')) {
            return;
        }
        var field = colorEncode[0], colorRange = colorEncode[1];
        var _b = seriesModel.getDataset().getExtreme(field), min = _b[0], max = _b[1];
        var colors = colorRange.split('-');
        return { field: field, min: min, max: max, colors: colors };
    };
    ColorLegend.prototype.beforeRender = function () {
        var _a = this.option, type = _a.type, orient = _a.orient, inverse = _a.inverse, position = _a.position, align = _a.align, offsetX = _a.offsetX, offsetY = _a.offsetY, splitNumber = _a.splitNumber;
        var sidePosition = this.chart.getSidePosition(this.id);
        var _b = this.chart.getPaddingBox(), top = _b.top, left = _b.left, right = _b.right, bottom = _b.bottom;
        var _c = this.state, start = _c.start, end = _c.end;
        var encodeInfo = this.getEncodeInfo();
        if (!encodeInfo) {
            return this.setState({ _valid: false });
        }
        var _d = this.getLegendSize(), dx = _d.x, dy = _d.y, width = _d.width, height = _d.height, outerWidth = _d.outerWidth, outerHeight = _d.outerHeight;
        var x;
        var y;
        var horizontalPosition = {
            start: left,
            center: (left + right) / 2 - outerWidth / 2,
            end: right - outerWidth,
        };
        var verticalPosition = {
            start: top,
            center: (top + bottom) / 2 - outerHeight / 2,
            end: bottom - outerHeight,
        };
        if (position === 'left') {
            x = sidePosition;
            y = verticalPosition[align];
        }
        else if (position === 'right') {
            x = sidePosition - outerWidth;
            y = verticalPosition[align];
        }
        else if (position === 'top') {
            y = sidePosition;
            x = horizontalPosition[align];
        }
        else if (position === 'bottom') {
            y = sidePosition - outerHeight;
            x = horizontalPosition[align];
        }
        x += offsetX + dx;
        y += offsetY + dy;
        this.setState({
            x: x,
            y: y,
            width: width,
            height: height,
        });
        this.setState({ _valid: true });
        var min = encodeInfo.min, max = encodeInfo.max, colors = encodeInfo.colors;
        var range = orient === 'horizontal' ? [x, x + width] : [y + height, y];
        if (inverse) {
            range.reverse();
        }
        this._scale = new LinearScale(min, max, range[0], range[1]);
        var startPosition = this._scale.scale(lodash.isNumber(start) ? start : min);
        var endPosition = this._scale.scale(lodash.isNumber(end) ? end : max);
        var items = type === 'continuous' ? [] : this.getPieces(min, max, splitNumber);
        this.setState({
            colors: colors,
            min: min,
            max: max,
            startPosition: startPosition,
            endPosition: endPosition,
            items: items,
        });
    };
    ColorLegend.prototype.getPieces = function (min, max, splitNumber) {
        var items = [];
        var step = (max - min) / splitNumber;
        for (var i = 0; i < splitNumber; i++) {
            var itemMin = min + step * i;
            var itemMax = i === splitNumber - 1 ? max : itemMin + step;
            items.push({
                min: itemMin,
                max: itemMax,
                visible: !this._invisibleItems.has(i),
            });
        }
        return items;
    };
    ColorLegend.prototype.handleItemClick = function (index) {
        var currentVisible = !this._invisibleItems.has(index);
        var visible = !currentVisible;
        var item = this.state.items[index];
        item.visible = visible;
        if (visible) {
            this._invisibleItems.delete(index);
        }
        else {
            this._invisibleItems.add(index);
        }
        var seriesModel = this.chart.getSeriesModel(0);
        var colorEncode = seriesModel.getOption().encode.color;
        var colorField = colorEncode[0];
        var dataset = seriesModel.getDataset();
        this.chart
            .getSeriesModel(0)
            .getState()
            .points.forEach(function (point, dataIndex) {
            var record = dataset.getRecord(dataIndex);
            var value = getValue(record, dataIndex, colorField);
            var biggerThanMin = index === 0 ? value >= item.min : value > item.min;
            var smallerThanMax = value <= item.max;
            if (biggerThanMin && smallerThanMax) {
                if (visible) {
                    seriesModel.invisibleItems.delete(dataIndex);
                }
                else {
                    seriesModel.invisibleItems.add(dataIndex);
                }
            }
        });
        this.chart.refresh();
    };
    ColorLegend.prototype.toggleHighlightItem = function (index, active) {
        var item = this.state.items[index];
        var seriesModel = this.chart.getSeriesModel(0);
        var colorEncode = seriesModel.getOption().encode.color;
        var colorField = colorEncode[0];
        var dataset = seriesModel.getDataset();
        if (!item.visible) {
            return;
        }
        this.chart
            .getSeriesModel(0)
            .getState()
            .points.forEach(function (point, dataIndex) {
            var value = dataset.getRecord(dataIndex)[colorField];
            var biggerThanMin = index === 0 ? value >= item.min : value > item.min;
            var smallerThanMax = value <= item.max;
            if (biggerThanMin && smallerThanMax) {
                seriesModel.toggleHighlightPoint(dataIndex, active, true);
            }
        });
    };
    ColorLegend.prototype.getFormatedText = function (min, max) {
        var _a = this.option, formatter = _a.formatter, text = _a.text;
        var list = text || [min, max];
        return list.map(function (value) { return (formatter ? formatter(value) : value); });
    };
    ColorLegend.prototype.renderHandleIcon = function () {
        var _a = this.option, orient = _a.orient, _b = _a.handleSize, handleIconWidth = _b[0], handleIconHeight = _b[1];
        var _c = this.state, x = _c.x, y = _c.y, width = _c.width, height = _c.height, startPosition = _c.startPosition, endPosition = _c.endPosition;
        var cx = x + width / 2;
        var cy = y + height / 2;
        var _d = this._handleIcons, startHandle = _d[0], endHandle = _d[1];
        startHandle.setAttr({
            rotation: orient === 'horizontal' ? 0 : degToRad(-90),
            cursor: orient === 'horizontal' ? 'ew-resize' : 'ns-resize',
            position: orient === 'horizontal'
                ? [startPosition - handleIconWidth / 2, cy - handleIconHeight / 2]
                : [cx - handleIconHeight / 2, startPosition + handleIconWidth / 2],
        });
        endHandle.setAttr({
            rotation: orient === 'horizontal' ? 0 : degToRad(-90),
            cursor: orient === 'horizontal' ? 'ew-resize' : 'ns-resize',
            position: orient === 'horizontal'
                ? [endPosition - handleIconWidth / 2, cy - handleIconHeight / 2]
                : [cx - handleIconHeight / 2, endPosition + handleIconWidth / 2],
        });
        return [startHandle, endHandle];
    };
    ColorLegend.prototype._updatePosition = function () {
        this._updateClipRect();
        this.renderHandleIcon();
        this.applyPosition();
    };
    ColorLegend.prototype.applyPosition = function () {
        var scale = this._scale;
        var _a = this.state, startPosition = _a.startPosition, endPosition = _a.endPosition;
        var start = scale.invert(startPosition);
        var end = scale.invert(endPosition);
        var min = Math.min(start, end);
        var max = Math.max(start, end);
        this.setState({ start: start, end: end });
        var seriesModel = this.chart.getSeriesModel(0);
        seriesModel.invisibleItems.clear();
        var encodeInfo = this.getEncodeInfo();
        var field = encodeInfo.field;
        seriesModel.getState().points.forEach(function (point, dataIndex) {
            var record = seriesModel.getDataset().getRecord(dataIndex);
            var value = getValue(record, dataIndex, field);
            if (!(value >= min && value <= max)) {
                seriesModel.invisibleItems.add(dataIndex);
            }
        });
        this.chart.refresh();
    };
    ColorLegend.prototype._getNextPosition = function (event) {
        var offsetX = event.offsetX, offsetY = event.offsetY;
        var offset = this.option.orient === 'horizontal' ? offsetX : offsetY;
        var positionRange = this._getPositionRange();
        var _a = this.state, startPosition = _a.startPosition, endPosition = _a.endPosition;
        if (this._dragSide === 'start') {
            startPosition = this._dragStartPosition + offset;
        }
        else {
            endPosition = this._dragStartPosition + offset;
        }
        startPosition = lodash.clamp(startPosition, positionRange[0], positionRange[1]);
        endPosition = lodash.clamp(endPosition, positionRange[0], positionRange[1]);
        return [startPosition, endPosition];
    };
    ColorLegend.prototype._updateClipRect = function () {
        var orient = this.option.orient;
        var _a = this.state, x = _a.x, y = _a.y, width = _a.width, height = _a.height, startPosition = _a.startPosition, endPosition = _a.endPosition;
        var rangeSize = endPosition - startPosition;
        this._clipRect.setAttr({
            x: orient === 'horizontal' ? startPosition : x,
            y: orient === 'horizontal' ? y : startPosition,
            width: orient === 'horizontal' ? rangeSize : width,
            height: orient === 'horizontal' ? height : rangeSize,
            fill: 'red',
        });
    };
    ColorLegend.prototype._getPositionRange = function () {
        var orient = this.option.orient;
        var _a = this.state, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        return orient === 'horizontal' ? [x, x + width] : [y, y + height];
    };
    ColorLegend.prototype.update = function (nextOption, mergeOld) {
        _super.prototype.update.call(this, nextOption, mergeOld);
        this.setState(this.getInitialState());
        this._invisibleItems.clear();
        this.setState(this.getInitialState());
    };
    ColorLegend.prototype.renderGradientBar = function () {
        var _this = this;
        var group = new Group({
            key: this.getKey('bar'),
        });
        var _a = this.option, orient = _a.orient, inverse = _a.inverse;
        var _b = this.state, x = _b.x, y = _b.y, width = _b.width, height = _b.height, colors = _b.colors;
        var pos = inverse ? [1, 0] : [0, 1];
        var gradientColor = new LinearGradient({
            x1: pos[0],
            y1: orient === 'horizontal' ? pos[0] : pos[1],
            x2: orient === 'horizontal' ? pos[1] : pos[0],
            y2: pos[0],
            stops: colors.map(function (color, index) {
                return {
                    offset: index / (colors.length - 1),
                    color: color,
                };
            }),
        });
        group.add(new Rect({
            key: 'background',
            x: x,
            y: y,
            width: width,
            height: height,
            fill: this.option.inactiveColor,
            transitionProperty: 'none',
        }));
        this._updateClipRect();
        this._panningBar.setAttr({
            key: this.getKey('range'),
            clip: this._clipRect,
            draggable: true,
            x: x,
            y: y,
            width: width,
            height: height,
            fill: gradientColor,
            onDragStart: function () { return _this.setState({ isDragging: true }); },
            getDragOffset: function () {
                return { x: 0, y: 0 };
            },
            onDrag: this.handleBarPanning,
            onDragend: function () { return _this.setState({ isDragging: false }); },
        });
        group.add(this._panningBar);
        return group;
    };
    ColorLegend.prototype.renderPieces = function () {
        var _this = this;
        var _a = this.option, inverse = _a.inverse, orient = _a.orient, splitNumber = _a.splitNumber, itemWidth = _a.itemWidth, itemHeight = _a.itemHeight, itemGap = _a.itemGap, itemStyle = _a.itemStyle, inactiveColor = _a.inactiveColor, itemSymbol = _a.itemSymbol;
        var _b = this.state, x = _b.x, y = _b.y, width = _b.width, height = _b.height, colors = _b.colors, items = _b.items;
        var group = new Group({
            key: this.getKey('slice'),
        });
        var colorScale = new ColorScale().domain([0, 1]).colors(colors);
        items.forEach(function (item, index) {
            var scaleValue = index / (splitNumber - 1);
            var itemColor = colorScale.scale(scaleValue);
            var itemX = orient !== 'horizontal'
                ? x
                : (inverse ? x + width - itemWidth : x) +
                    (itemWidth + itemGap) * index * (inverse ? -1 : 1);
            var itemY = orient === 'horizontal'
                ? y
                : (inverse ? y : y + height - itemHeight) +
                    (itemHeight + itemGap) * index * (inverse ? 1 : -1);
            group.add(createSymbol({
                symbol: itemSymbol,
                lineWidth: 0,
                stroke: null,
            }, {
                x: itemX,
                y: itemY,
                width: itemWidth,
                height: itemHeight,
            }, __assign(__assign({ key: "item" + index, fill: item.visible ? itemColor : inactiveColor, cursor: 'pointer' }, _this.getShapeStyle(itemStyle)), { r: itemStyle === null || itemStyle === void 0 ? void 0 : itemStyle.borderRadius, onClick: function () { return _this.handleItemClick(index); }, onMouseOver: function () { return _this.toggleHighlightItem(index, true); }, onMouseOut: function () { return _this.toggleHighlightItem(index, false); } })));
        });
        return group;
    };
    ColorLegend.prototype.renderText = function () {
        var _a = this.state, x = _a.x, y = _a.y, width = _a.width, height = _a.height, min = _a.min, max = _a.max;
        var _b = this.option, orient = _b.orient, inverse = _b.inverse, textGap = _b.textGap;
        var text = this.getFormatedText(min, max);
        var textList = [];
        var side = {
            start: orient === 'horizontal' ? 'left' : 'bottom',
            end: orient === 'horizontal' ? 'right' : 'top',
        };
        var startPosition = getRectLabelPosition({
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
        }, side[inverse ? 'end' : 'start'], textGap);
        var endPosition = getRectLabelPosition({
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
        }, side[inverse ? 'start' : 'end'], textGap);
        textList.push(new Text(__assign(__assign({ key: this.getKey('start-text'), text: text[0] }, startPosition), this.getTextStyle(this.option.textStyle))));
        textList.push(new Text(__assign(__assign({ key: this.getKey('end-text'), text: text[1] }, endPosition), this.getTextStyle(this.option.textStyle))));
        return textList;
    };
    ColorLegend.prototype.updated = function () {
        this.init();
    };
    ColorLegend.prototype.render = function () {
        var _this = this;
        this._handleIcons.forEach(function (icon) { return icon.setAttr(_this.getShapeStyle(_this.option.handleStyle)); });
        if (this.state.isDragging) {
            return this.renderObj;
        }
        if (!this.option.show || !this.state._valid) {
            return null;
        }
        var group = new Group({
            key: this.getKey('colorLegend'),
        });
        if (!this.option.show) {
            return group;
        }
        if (this.option.type === 'continuous') {
            group.add(this.renderGradientBar());
            group.addAll(this.renderHandleIcon());
        }
        else if (this.option.type === 'piecewise') {
            group.add(this.renderPieces());
        }
        group.addAll(this.renderText());
        return group;
    };
    return ColorLegend;
}(ComponentModel));
export default ColorLegend;
registerComponent('colorLegend', ColorLegend);
